import { CascaderOptionType, FilledFieldNamesType, ShowSearchType } from 'antd/lib/cascader'

/**
 * Ant Design Cascader の名称検索用。
 * 予約詳細の売掛先 Select（showSearch）と同様に、ラベル部分一致で絞り込む。
 */
export const cascaderNameSearch: ShowSearchType = {
  filter: (inputValue: string, path: CascaderOptionType[], _names: FilledFieldNamesType) =>
    path.some(option =>
      String(option.label ?? '')
        .toLowerCase()
        .includes(inputValue.toLowerCase()),
    ),
}
